import '@antiopix/shared-ui/css/reset.css';
import '@antiopix/shared-ui/css/tokens.css';
import '@antiopix/shared-ui/css/typography.css';
import '@antiopix/shared-ui/css/glassmorphism.css';
import '@antiopix/shared-ui/css/animations.css';
import '@antiopix/shared-ui/css/components.css';
import './main.css';

import { initPage } from '@antiopix/shared-ui/js/page-init.js';

initPage();
